exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1u7NJSARgUb4HaqNNGlx09{padding:1.42857rem}@media only screen and (min-width:640px){._1u7NJSARgUb4HaqNNGlx09{padding:2.14286rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"MarkAttendanceCourseView": "_1u7NJSARgUb4HaqNNGlx09"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.3/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/Attendance/MarkAttendance/MarkAttendanceCourseView/style.postcss
// module id = 1391
// module chunks = 0